/**
 * QR Tracking — Storefront Script
 *
 * window.QRConfig is set inline by qr-gate.liquid (theme settings).
 * Runs on both PDP pages and collection pages.
 *
 *  PDP:
 *  1. Price/ATC already hidden by CSS in qr-gate.liquid (no flash)
 *  2. If ?s= param present: validates via App Proxy
 *  3. Valid   → reveal price/ATC/sticky + set cart attribute
 *  4. Invalid → keep hidden, show gate message
 *
 *  Collection:
 *  1. Product card price/quick-add/quick-view hidden via .qr-card-hidden class
 *  2. If ?s= param present: validates via App Proxy
 *  3. Valid   → remove .qr-card-hidden from all cards, append ?s= to card links
 *  4. Invalid → keep hidden (simple cards only)
 */

(function () {
  "use strict";

  var cfg = window.QRConfig;
  if (!cfg || !cfg.enabled) return;

  // ── Selectors ──────────────────────────────────────────────────────────────
  var PRICE_SEL         = ".xo-product-info-content__price";
  var BUY_FORM_SEL      = ".xo-product-info-content__buy-form";
  var DYN_CHECKOUT_SEL  = ".shopify-payment-button__group";
  var STICKY_PRICE_SEL  = ".xo-sticky-cart__info-price";
  var STICKY_QTY_SEL    = ".xo-sticky-cart__action-quantity";
  var STICKY_CART_SEL   = ".xo-sticky-cart__action-cart";
  var GATE_ID           = "qr-gate-message";
  var SKELETON_CLASS    = "qr-skeleton-shimmer";

  // Card selectors (collection pages)
  var CARD_HIDDEN_CLASS = "qr-card-hidden";

  // ── Helpers ─────────────────────────────────────────────────────────────────
  function qs(sel) { return document.querySelector(sel); }
  function qsa(sel) { return document.querySelectorAll(sel); }

  function revealBlock(el) { if (el) el.style.display = "block"; }
  function revealNatural(el) { if (el) el.style.removeProperty("display"); }
  function hide(el) { if (el) el.style.display = "none"; }

  function replaceWithSkeleton(el, id) {
    if (!el) return null;
    var skEl = document.createElement("div");
    skEl.className = SKELETON_CLASS;
    skEl.id = id || "";
    skEl.style.minHeight = (el.offsetHeight || 48) + "px";
    el.parentNode.insertBefore(skEl, el);
    return skEl;
  }

  function removeSkeleton(skEl) {
    if (skEl && skEl.parentNode) skEl.parentNode.removeChild(skEl);
  }

  function showGateMessage() {
    if (document.getElementById(GATE_ID)) return;
    var anchor = qs(PRICE_SEL) || qs(BUY_FORM_SEL);
    if (!anchor) return;

    var gate = document.createElement("div");
    gate.id = GATE_ID;
    gate.style.cssText = [
      "padding:14px 18px",
      "border:1px solid #e5e5e5",
      "border-radius:8px",
      "background:#f9f9f9",
      "font-size:13px",
      "color:#6d7175",
      "line-height:1.6",
      "margin-top:12px",
    ].join(";");
    gate.innerHTML =
      "<strong style=\"color:#202223\">" + (cfg.gateHeading || "Member access required") + "</strong><br>" +
      (cfg.gateMessage || "This product is available exclusively through a member QR link. Please scan your QR code or use your personal link to view pricing.");

    anchor.parentNode.insertBefore(gate, anchor.nextSibling);
  }

  // ── Cart attribute ──────────────────────────────────────────────────────────
  function setCartAttribute(key, value) {
    var attributes = {};
    attributes[key] = value;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ attributes: attributes }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        console.log("[QR] Cart attribute set:", data.attributes);
      })
      .catch(function (err) {
        console.error("[QR] Failed to set cart attribute:", err);
      });
  }

  // ── Page detection ──────────────────────────────────────────────────────────
  function isPDP() {
    return !!document.querySelector(".xo-product-info-content");
  }

  function isCollectionPage() {
    return !!document.querySelector(".xo-main-collection") ||
           /\/collections\//.test(window.location.pathname);
  }

  // ── Collection page logic ──────────────────────────────────────────────────
  function initCollection() {
    var sParam = new URLSearchParams(window.location.search).get("s");

    if (!sParam) {
      // No ?s= — cards stay hidden (simple display only)
      console.log("[QR] Collection page without ?s= — prices/ATC hidden");
      return;
    }

    console.log("[QR] Collection page with ?s=" + sParam + " — validating...");

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var validateUrl = root + "apps/qr-tracking/api/storefront?s=" + encodeURIComponent(sParam);

    fetch(validateUrl)
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then(function (data) {
        if (data.valid) {
          console.log("[QR] Valid member — revealing prices/ATC on collection cards");
          revealCardElements();
          appendTrackingToCardLinks(sParam);
          setCartAttribute("s", sParam);

          // Re-apply after AJAX pagination / filtering swaps the product grid
          if (window.xoFilters) {
            window.xoFilters.on("done", function () {
              revealCardElements();
              appendTrackingToCardLinks(sParam);
            });
          }
        } else {
          console.log("[QR] Invalid member ref — keeping cards simple");
        }
      })
      .catch(function (err) {
        console.warn("[QR] Collection validation failed:", err.message);
      });
  }

  function revealCardElements() {
    var hidden = qsa("." + CARD_HIDDEN_CLASS);
    for (var i = 0; i < hidden.length; i++) {
      hidden[i].classList.remove(CARD_HIDDEN_CLASS);
    }
    console.log("[QR] Revealed " + hidden.length + " hidden card elements");
  }

  function appendTrackingToCardLinks(sParam) {
    // Add ?s= to all product card links so PDP pages also get the tracking param
    var cardLinks = qsa(".xo-product-card__url, .xo-product-card__image-link");
    for (var i = 0; i < cardLinks.length; i++) {
      var link = cardLinks[i];
      var href = link.getAttribute("href");
      if (href && href.indexOf("s=") === -1) {
        var separator = href.indexOf("?") === -1 ? "?" : "&";
        link.setAttribute("href", href + separator + "s=" + encodeURIComponent(sParam));
      }
    }
    console.log("[QR] Appended ?s= to " + cardLinks.length + " card links");
  }

  // ── PDP logic ──────────────────────────────────────────────────────────────
  function initPDP() {
    var priceEl      = qs(PRICE_SEL);
    var buyFormEl    = qs(BUY_FORM_SEL);
    var dynCheckout  = qs(DYN_CHECKOUT_SEL);
    var stickyPrice  = qs(STICKY_PRICE_SEL);
    var stickyQty    = qs(STICKY_QTY_SEL);
    var stickyCart   = qs(STICKY_CART_SEL);

    var sParam = new URLSearchParams(window.location.search).get("s");
    var handle = window.location.pathname.replace(/\/$/, "").split("/").pop();

    if (!sParam) {
      if (cfg.hidePricesGlobally) {
        hide(stickyPrice);
        hide(stickyQty);
        hide(stickyCart);
        showGateMessage();
      }
      return;
    }

    var skPrice = replaceWithSkeleton(priceEl, "qr-sk-price");
    var skBuy   = replaceWithSkeleton(buyFormEl, "qr-sk-buy");
    hide(stickyPrice);
    hide(stickyQty);
    hide(stickyCart);

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
    var validateUrl = root + "apps/qr-tracking/api/validate-ref?s=" +
      encodeURIComponent(sParam) + "&handle=" + encodeURIComponent(handle);

    fetch(validateUrl)
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then(function (data) {
        removeSkeleton(skPrice);
        removeSkeleton(skBuy);

        if (data.valid) {
          revealBlock(priceEl);
          revealBlock(buyFormEl);
          revealBlock(dynCheckout);
          revealNatural(stickyPrice);
          revealNatural(stickyQty);
          revealNatural(stickyCart);
          setCartAttribute("s", sParam);
        } else {
          showGateMessage();
        }
      })
      .catch(function (err) {
        console.warn("[QR] Validation failed:", err.message);
        removeSkeleton(skPrice);
        removeSkeleton(skBuy);
        showGateMessage();
      });
  }

  // ── Main ────────────────────────────────────────────────────────────────────
  function init() {
    if (isPDP()) {
      initPDP();
    } else if (isCollectionPage()) {
      initCollection();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
